import { Component, Inject, OnInit, OnDestroy} from '@angular/core';
import _ from 'lodash';
import {moment,async} from '../../../js/globals';
import { ClientLoggerService } from '../../services/client-logger.service';
import { MySynchDataStore } from '../../data-stores/mysynch.datastore';
import { MySynchConstantService } from '../../services/mysynch.constant.service';
import { MySynchEnumerationService } from '../../services/mysynch.enumeration.service';
import { PerformanceMetricsService } from '../../services/performance-metrics.service';
import { PerformanceContextService } from '../../services/performance-context.service';
import { PerformanceContext} from '../../interfaces/mysynch.interfaces';
@Component({
  standalone: false,
  selector: 'journal',
  templateUrl: '../app/pages/journal/journal.view.html',
  styleUrls:['../app/pages/journal/journal.style.css']
})
export class Journal implements OnInit , OnDestroy{

    private performanceContext: PerformanceContext | null = null;
    private incompleteSetupMessage:string = '';
    private hasMsfReadyHappened:boolean = false;
    private updatePermissionCode:string = 'JOURNAL_UPDATE';
    private showMoreCount:number			= 20;
    private shownCount:number				= 0;
    private fullView:boolean				= false;
    private paramId:number				    = 0;
    // --- Dropdown Lists ---
    private journalCategories:any		= this.MSF.lists.journalCategory;

    // subscriptions and deregister functions
    private herdChangeSubscription: any;

    canUpdate:boolean = false;
    readOnly:boolean  = true;
    loading:boolean   = true;

    dataUpdatedDate:any    	= null;
    dateFormat:any			= null;

    hasUpdatePermission:boolean = false;
    filteredGridData:any = [];
    journalGridData:any = [];
    lineItems:any = [];
    journalData:any = [];
    
    _:any;

    constructor(@Inject('MySynchFactory') private MSF:any,
                @Inject('ApiFactory') private api:any,
                @Inject('ViewAuthorizationFactory') private viewAuth,
                @Inject(MySynchEnumerationService) private mySynchEnumSvc:MySynchEnumerationService,
                @Inject(MySynchDataStore) private mysynchDataStore:MySynchDataStore,
                @Inject(MySynchConstantService) private mySynchConstantService:MySynchConstantService,
                @Inject(PerformanceMetricsService) private perfMetricSvc:PerformanceMetricsService,
                @Inject(PerformanceContextService) private perfContextSvc:PerformanceContextService,
                @Inject(ClientLoggerService) private log:ClientLoggerService
                ){
                    this._ = _;

                }

    private checkPermissions() {
        this.canUpdate = true; 
        this.readOnly  = this.viewAuth.hasPermission('COMMON_SETTINGS_READ');
        }

   

    private updateDataGrid() {
        this.filteredGridData = this.filterDataset();
    }

    private journalRows = (lineItems) => {
        var id				= this._.get(lineItems, 'id');
        var herdId			= this._.get(lineItems, 'herdId');
        var date			= this._.get(lineItems, 'date');
        var category		= this._.get(lineItems, 'category');
        var description		= this._.get(lineItems, 'description',    '');
        var viewableCreatedUser		= this._.get(lineItems, 'viewableCreatedUser',  '');
        var viewableCreatedDate		= this._.get(lineItems, 'viewableCreatedDate',  '');
        var viewableModifiedUser	= this._.get(lineItems, 'viewableModifiedUser', '');
        var viewableModifiedDate	= this._.get(lineItems, 'viewableModifiedDate', '');
        var localDate				= moment(date).subtract(moment(date).utcOffset(), 'minutes');


        return {
            id:				id,
            herdId:			herdId,
            date:			moment(new Date(date)).format(this.dateFormat),
            category:		category,
            description:	description,
            viewableCreatedUser:	viewableCreatedUser,
            viewableModifiedUser:	viewableModifiedUser,
            viewableCreatedDate:	moment(new Date(viewableCreatedDate) ).format(this.dateFormat),
            viewableModifiedDate:	moment(new Date(viewableModifiedDate)).format(this.dateFormat),
            localDate:				moment(new Date(localDate.toDate())).format('YYYY-MM-DD'),	// for ordering
            displayDate:			moment(new Date(localDate.toDate())).format(this.dateFormat)
        };
    }

    private loadReportData() {
        return new Promise((resolve, reject) => {
            this.loading                = true;
            this.lineItems              = [];
            this.incompleteSetupMessage = '';
            this.dataUpdatedDate		= '';

            this.journalData   = [];

            var herdId = _.get(this.MSF.getActiveHerd(),"herdId");

            async.auto({
                getJournal: (done) => {
                    this.perfMetricSvc.startTiming('Page:JournalPageData:Request');
                    this.api.getJournalByHerd(herdId, this.performanceContext, 
                        (err, data)=> {
                            this.perfMetricSvc.endTiming("page",'Page:JournalPageData:Request', this.performanceContext);
                            if (err) {
                                this.log.error('Error getting journal data: ' + err);
                            }
                            this.journalData	= data;
                            this.loading		= false;

                            return done(err, data);
                    });
                }

            }, (err, data)=> {
                this.perfMetricSvc.startTiming('Page:Journal:Build')
                        this.loading = false;
                        if (err) {
                            var errorData = this.journalData;
                            this.MSF.notify.danger('Unable to load journal data');
                            if (errorData.statusCode === 403) { // 403 indicates setup is not complete and should have display message in response
                                this.incompleteSetupMessage = errorData.statusText;
                            }
                            this.perfMetricSvc.endTiming("page",'Page:Journal:Build', this.performanceContext);
                            resolve(true);
                        }

                    // --- Prep Data to Display ---
                    var dt = this.MSF.activeHerd.latestReportDate;
                    var metaDateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
                    var longDateFormat = this.MSF.getLongDateFormatFromMetaFormatString(metaDateFormat,this.mySynchConstantService.defaultDateSeparator);
                    this.dataUpdatedDate = moment(dt).subtract(moment(dt).utcOffset(), 'minutes').format(longDateFormat);
                    this.journalGridData = this._.sortByOrder(this._.map(this.journalData, this.journalRows), 'localDate', 'DESC');

                    this.updateDataGrid();
                    this.perfMetricSvc.endTiming("page",'Page:Journal:Build', this.performanceContext);
                    resolve(true);
                }
            );
        });
    }

    addJournal() {
        this.MSF.loadPage('NewJournal', {cameFrom: 'Journal'});
    };

    editJournal(row) {
        this.MSF.loadPage('JournalEdit', {id: row.id, cameFrom: 'Journal'});
    };

    deleteJournal(row) {
        this.MSF.confirm({
            title:   'Delete Entry',
            message: 'Are you sure you want to delete this entry? \n' +  
                row.displayDate + ' - ' +
                this._.find(this.MSF.lists.journalCategory, {code: row.category}).name,
            confirm: {
                className: 'danger',
                icon: 'trash'
            }
        }, () => {
            this.loading = true;

            this.api.deleteJournal(row.herdId, row.id, this.MSF.cookies.user.PersonId, (err, result) => {
                this.loading = false;

                if (err) {
                    var errorMessage = 'Error deleting journal entry!';

                    this.log.error(errorMessage + ': ' + err);

                    return this.MSF.notify.danger(errorMessage);
                }

                this.MSF.notify.success('Journal item deleted successfully');

                // -- redisplay the list without the soft-deleted journal item
                this._.remove(this.filteredGridData, (o) => { return (o.id == row.id ); });
                this._.remove(this.journalGridData,  (o) => { return (o.id == row.id ); });
                this.shownCount -= this._.size(this.filteredGridData)-1;
                this.updateDataGrid();
            });
        }, ()=> {
            return this.log.debug('Cancelled!');
        });
    };

    filterDataset() {
        var passedId = Number(this.MSF.state.params.id);
        var showCnt  = this.showMoreCount;

        this.paramId = passedId;

        if (passedId && passedId > 0) {
            showCnt				= this.journalGridData.map(o => o.id).indexOf(passedId) + 1;
            this.fullView		= true;
            this.MSF.state.params.id	= null;
        } else {
            showCnt				= this.shownCount + this.showMoreCount;
            this.fullView		= false;
            this.paramId		= 0;
        }

        var arraySize	= this._.size(this.journalGridData) - 1;
        this.shownCount	= (showCnt > arraySize ? arraySize : showCnt);

        this.filteredGridData = this.journalGridData.slice(0, showCnt);
        return this.filteredGridData;
    };
    setupIsIncomplete(){
        return this.incompleteSetupMessage !== '';
    };
    getIncompleteSetupMessages() {
        return this.incompleteSetupMessage.split('|');
    };
    getTerritoryManager() {
        return this.MSF.getActiveFarmTerritoryManager();
    };

    ngOnDestroy(): void {
        if (this.herdChangeSubscription) {
            this.herdChangeSubscription.unsubscribe();
        }
        this.performanceContext = null;
    }

    ngOnInit() {
        this.MSF.ready(()=> {
            
            this.hasMsfReadyHappened = true;
            this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
            this.checkPermissions();
            this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();

            this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(this.MSF.getActiveHerd(), 'herdId', null));
            this.perfMetricSvc.startTiming('Page:Journal:Render');
            this.loadReportData().then(() => {
                this.perfMetricSvc.markPageReady('Page:Journal:Render', this.performanceContext);
            });

            this.herdChangeSubscription = this.mysynchDataStore.currentActiveHerd
            .subscribe((herd)=>{
                if(!this.MSF.isNullish(herd) && !this.loading) {
                    if (this.hasMsfReadyHappened) {
                        this.checkPermissions();
                        this.hasUpdatePermission = this.viewAuth.hasPermission(this.mySynchEnumSvc.getMySynchEnumeration('Permission',this.updatePermissionCode));
                        this.dateFormat = this.MSF.getActiveHerdTimeFormatWithLongDigitYear();
                        this.performanceContext = this.perfContextSvc.createPerformanceContext(_.get(herd, 'herdId', null));
                        this.perfMetricSvc.startTiming('Page:JournalOnHerdChange:Render');
                        this.loadReportData().then(() => {
                            this.perfMetricSvc.markPageReady('Page:JournalOnHerdChange:Render', this.performanceContext);
                        });
                    }
                }
            });
        });
    }

    
    
}